import type { TrigKey } from './keys';

export const it: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'Matematica · Trigonometria',
  'panel.experiment': 'Esperimento',
  'panel.params': 'Parametri',
  'panel.scene': 'Scegli un esperimento',
  'experiment.right-triangle.label': 'Triangolo rettangolo',
  'experiment.unit-circle.label': 'Cerchio unitario',
  'experiment.wave-studio.label': 'Studio delle onde',
  'experiment.identity-playground.label': 'Identità',
  'experiment.triangle-solver.label': 'Risolutore di triangoli',
  'experiment.circular-polar.label': 'Circolare e polare',
  'hint.line1': 'Trascina i punti e sposta i cursori.',
  'hint.line2': 'Il contenuto educativo vive nella geometria, non nel testo.',
  'rt.angle.a': 'Angolo A',
  'rt.angle.b': 'Angolo B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'Radianti',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': 'Aggancia a 30°/45°/60°',
  'uc.units': 'Unità',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'Mostra ASTC',
  'uc.snap.common': 'Aggancia ad angoli comuni',
  'uc.angle.value': '∠',
  'uc.units.deg': 'gradi',
  'uc.units.rad': 'rad',
  'uc.units.both': 'gradi+rad',
  'ws.fn': 'Funzione',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — Ampiezza',
  'ws.frequency': 'B — Frequenza',
  'ws.phase': 'C — Sfasamento',
  'ws.shift': 'D — Traslazione verticale',
  'ws.rform.toggle': 'Derivazione forma R',
  'ws.rform.a': 'a (coef. sin)',
  'ws.rform.b': 'b (coef. cos)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'Reimposta',
  'ws.base': 'Mostra curva base',
  'ip.id.pythagorean': 'Pitagorica',
  'ip.id.reciprocal': 'Reciproca',
  'ip.id.quotient': 'Quoziente',
  'ip.id.sum': 'Somma',
  'ip.id.difference': 'Differenza',
  'ip.id.double': 'Angolo doppio',
  'ip.id.half': 'Angolo metà',
  'ip.play': 'Riproduci',
  'ip.pause': 'Pausa',
  'ip.step': 'Passo',
  'ip.reset': 'Reimposta',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note':
    'Disponibile in v2 — questa dimostrazione richiede una costruzione più elaborata.',
  'ts.area': 'Area',
  'ts.sineRule': 'Teorema dei seni',
  'ts.cosineRule': 'Teorema del coseno',
  'ts.ambiguous.toggle': 'Mostra triangolo fantasma se ambiguo',
  'ts.reset': 'Reimposta a equilatero',
  'ts.snap.integers': 'Aggancia a interi',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'Lati',
  'ts.section.angles': 'Angoli',
  'ts.section.sineRule': 'Teorema dei seni',
  'ts.section.cosineRule': 'Teorema del coseno',
  'ts.section.area': 'Area',
  'cp.omega': 'Velocità angolare',
  'cp.plot.y': 'Traccia y (sin)',
  'cp.plot.x': 'Traccia x (cos)',
  'cp.polar.label': 'Figura polare',
  'cp.polar.circle': 'Cerchio (r = 1)',
  'cp.polar.rose': 'Rosa (r = sin 3θ)',
  'cp.polar.cardioid': 'Cardioide (r = 1 + cos θ)',
  'cp.polar.limacon': 'Limaçon (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'Approssimazione piccoli angoli (sin x ≈ x)',
  'cp.play': 'Riproduci',
  'cp.pause': 'Pausa',
  'cp.reset': 'Reimposta',
  'cp.step': 'Passo π/12',
};
